import { Button, Stack, SvgIconProps, SxProps, Theme, Typography, TypographyProps, useTheme } from '@mui/material';
import React from 'react';

interface ButtonProps {
  label: string;
  onClick: () => void;
}

interface Props {
  icon?: React.ElementType<SvgIconProps>;
  title: string;
  titleVariant?: TypographyProps['variant'];
  titleColor?: TypographyProps['color'];
  content: string;
  contentVariant?: TypographyProps['variant'];
  button?: ButtonProps;
  sx?: SxProps<Theme>;
}

const EmptyStateOverview: React.FC<Props> = ({
  icon: Icon,
  title,
  titleVariant = 'h4',
  titleColor = 'textPrimary',
  content,
  contentVariant = 'body1',
  button,
  sx
}) => {
  const theme = useTheme();
  const stackSx: SxProps<Theme> = sx ?? { flex: 1, py: 8 };

  return (
    <Stack direction="column" alignItems="center" justifyContent="center" spacing={1.5} sx={stackSx}>
      {Icon && <Icon sx={{ width: 48, height: 48, color: theme.palette.text.secondary }} />}
      <Typography variant={titleVariant} color={titleColor}>
        {title}
      </Typography>
      <Typography
        variant={contentVariant}
        color="textSecondary"
        align="center"
        sx={{ maxWidth: '30em', whiteSpace: 'pre-line' }}
      >
        {content}
      </Typography>
      {button && (
        <Button id="empty-state-button" variant="contained" onClick={button.onClick}>
          {button.label}
        </Button>
      )}
    </Stack>
  );
};

export default EmptyStateOverview;
